import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import customizableQuery from '~/graphql/customizable.gql';
function fetchCustomizable(_x, _x2) {
  return _fetchCustomizable.apply(this, arguments);
}
function _fetchCustomizable() {
  _fetchCustomizable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, code) {
    var locale, _yield$context$app$ap, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          locale = context.state.i18n.currentLocale.iso;
          _context.next = 3;
          return context.app.apolloProvider.defaultClient.query({
            query: customizableQuery,
            variables: {
              locale: locale,
              code: code
            }
          });
        case 3:
          _yield$context$app$ap = _context.sent;
          data = _yield$context$app$ap.data;
          return _context.abrupt("return", data.customizable);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchCustomizable.apply(this, arguments);
}
export { fetchCustomizable };